/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type CommentNotificationBody_notification = {
    readonly comment: {
        readonly " $fragmentRefs": FragmentRefs<"NotificationCommentContainer_comment">;
    } | null;
    readonly commentReply: {
        readonly " $fragmentRefs": FragmentRefs<"NotificationCommentContainer_comment">;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"NotificationCommentContainer_notification">;
    readonly " $refType": "CommentNotificationBody_notification";
};
export type CommentNotificationBody_notification$data = CommentNotificationBody_notification;
export type CommentNotificationBody_notification$key = {
    readonly " $data"?: CommentNotificationBody_notification$data;
    readonly " $fragmentRefs": FragmentRefs<"CommentNotificationBody_notification">;
};



const node: ReaderFragment = (function () {
    var v0 = [
        ({
            "args": null,
            "kind": "FragmentSpread",
            "name": "NotificationCommentContainer_comment"
        } as any)
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "CommentNotificationBody_notification",
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "comment",
                "plural": false,
                "selections": (v0 /*: any*/),
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "commentReply",
                "plural": false,
                "selections": (v0 /*: any*/),
                "storageKey": null
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "NotificationCommentContainer_notification"
            }
        ],
        "type": "Notification",
        "abstractKey": null
    } as any;
})();
(node as any).hash = 'b51689cbd864c125b2765722ca119760';
export default node;
